import axios from 'axios';

export const baseURL = 'https://brain-quiz-backend.onrender.com/api/v1'; // Replace with your API base URL

const httpService = axios.create({
  baseURL,
});

// Request interceptor
httpService.interceptors.request.use(
  (config) => {
    // fetch accessToken from localstorage's persist-root
    const persistRoot = JSON.parse(localStorage.getItem('persist:root'));
    const auth = JSON.parse(persistRoot?.auth);
    const accessToken = auth?.userData?.accessToken;

    // Set the Content-Type header
    config.headers['Content-Type'] = 'application/json';

    // Set the Authorization header with the access token
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    // Handle request error
    console.error('Request error:', error.message);
    return Promise.reject(error);
  }
);

// Response interceptor
httpService.interceptors.response.use(
  (response) => {
    // Extract and return response data
    return response.data;
  },
  (error) => {
    // Handle network errors
    if (!error.response) {
      console.error('Network error:', error.message);
      // Handle network error (e.g., display a user-friendly message)
      return Promise.reject(error);
    }

    // Handle response errors
    const { status, data } = error.response;
    console.error(`Response error (status ${status}):`, data);

    // Handle specific error scenarios based on status codes

    return Promise.reject(error);
  }
);

export default httpService;
